<template>
  <div id="headerView">
    <header role="banner">
      <section class="top-bar">
        <div class="container">
          <div class="row">
            <div class="col-6 col-sm-6 col-md-7 col-lg-5 logo">
              <div class="logo-div">
                <router-link tag="a" to="/" class="left-padding" :title="$t('message.link-oslomet')">
                  <img alt="" width="72px" height="45px" src="../assets/images/oslomet_logo_white_tekst.svg" :title="$t('message.to-the-mainpage')" >
                </router-link>
                <router-link tag="a" to="/" class="no-underline">
                  <h4 class="logo-heading">LEXIN</h4>
                  <span>{{ $t('message.lexin-logo-content') }}</span>
                </router-link>
              </div>
            </div>
            <div class="col-6 col-sm-6 col-md-5 col-lg-7">
              <div class="float-right">
              <ul class="right-nav">
                <li>
                  <a
                    href="javascript:void(0)"
                    class="no-bdr"
                    role="button"
                    @click="zoomOut()"
                    title="Smaller font size"
                  >A-</a>
                </li>
                <li>
                  <a
                    href="javascript:void(0)"
                    class="no-bdr"
                    role="button"
                    @click="zoomIn()"
                    title="Larger font size"
                  >A+</a>
                </li>
              </ul>
               <button
                  aria-controls="navbarTogglerDemo03"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                  class="navbar-toggler menu-btn"
                  data-target="#navbarSupportedContent"
                  data-toggle="collapse"
                  type="button"
                >
                  <span class="navbar-toggler-icon">&nbsp;</span>
                  <span class="navbar-toggler-icon">&nbsp;</span>
                  <span class="navbar-toggler-icon">&nbsp;</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="main-nav">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <!-- <div class="mobile-nav">
                <a class="navbar-brand" href="javascript:void(0)" style="display:none">Navigation</a>
              </div> -->
              <nav class="navbar navbar-expand-lg navbar-light" role="navigation" title="Header Navigation">
                <div class="collapse navbar-collapse" id="navbarSupportedContent">
                  <ul class="navbar-nav mr-auto">
                    <li class="nav-item">
                      <router-link
                        tag="a"
                        class="nav-link"
                        to="/"
                        v-bind:active-class="$route.path.includes('/findwords') ? 'router-link-exact-active router-link-active' : ''"
                      >{{ $t('message.main-page') }}</router-link>
                    </li>
                    <li
                      class="nav-item"
                      @mouseover="onmouseover"
                      @mouseleave="onmouseleave">
                      <div class="dropdown">
                      <a
                        aria-expanded="false"
                        aria-haspopup="true"
                        class="nav-link dropdown-toggle"
                        data-toggle="dropdown"
                        href="#"
                        id="navbarDropdown"
                        role="button"
                        @click="showhidedropdown()"
                        v-html="droplist"
                      ></a>
                    <nav aria-labelledby="navbarDropdown" class="dropdown-menu" :aria-label="$t('message.dropdown-menu')">
                        <a
                          class="dropdown-item"
                          href="javascript:void(0)"
                          @click="navigate('AboutComponent',$t('message.about'))"
                        >{{ $t('message.about') }}</a>
                        <a
                          class="dropdown-item"
                          href="javascript:void(0)"
                          @click="navigate('AboutSearchComponent',$t('message.about-search'))"
                        >{{ $t('message.about-search') }}</a>
                        <a
                          class="dropdown-item"
                          href="javascript:void(0)"
                          @click="navigate('AboutSpeechComponent',$t('message.about-speech'))"
                        >{{ $t('message.about-speech') }}</a>
                        <a
                          class="dropdown-item"
                          href="javascript:void(0)"
                          @click="navigate('PrintedDictionariesComponent',$t('message.list-printed'))"
                        >{{ $t('message.list-printed') }}</a>
                      </nav>
                      </div>
                    </li>
                    <li class="nav-item">
                        <router-link
                            tag="a"
                            class="nav-link"
                            :lang = selectedLanguageCode
                            :to="{ name: 'DomainListComponent'}"
                        >{{ $t('message.lexin-exam') }}</router-link>
                    </li>
                    <li class="nav-item">
                      <router-link
                        tag="a"
                        aria-label="Contact Us Page Navigation using nav"
                        class="nav-link"
                        :to="{ name: 'ContactUsComponent'}"
                      >{{ $t('message.contact-us') }}</router-link>
                    </li>
                  </ul>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </section>
    </header>
  </div>
</template>

<script>
export default {
  name: "HeaderView",
  data() {
    return {
      width: 90,
      scale: 1.0,
      droplist: this.$t("message.about"),
      click: false,
      languageCodeList:[
        {lang:'eng',langISOCode:'en'},
        {lang:'nny',langISOCode:'nn'},
        {lang:'nbo',langISOCode:'nb'}
      ]
    };
  },
  computed: {
    selectedLanguageCode () {
      return this.languageCodeList.find(x=>x.lang==localStorage.getItem('lang')).langISOCode;
    },
  },

  methods: {
    nav(val) {
      this.droplist = this.$t("message.about");
      this.$router.push({ name: val });
    },
    navigate(val, text) {
      this.$router.push({ name: val }).then(() => console.log('Navigated!'))
    .catch((err) => {
      console.log('err', err);
    });
      this.droplist = text;
      if (screen.width > 992) {
        $('.dropdown-menu .dropdown-toggle').dropdown('toggle');
        $(".dropdown-toggle").unbind("click");
      } else {
        this.showhidedropdown();
      }
    },
    zoomIn() {
      if (this.width < 130 || this.scale < 1.15) {
        this.width += 15;
        this.scale += 0.05;
        $("body").css("zoom", this.width + "%");
        $("body").css("-moz-transform", "scale(" + this.scale + ")");
      }
    },
    zoomOut() {
      if (this.width > 90 || this.scale > 1.0) {
        this.width -= 15;
        this.scale -= 0.05;
        $("body").css("zoom", this.width + "%");
        $("body").css("-moz-transform", "scale(" + this.scale + ")");
      }
    },
    showhidedropdown() {
      if (screen.width < 992) {
        if (this.click == false) {
          this.click = !this.click;
          if (this.click == true) {
            $(".dropdown-menu").dropdown('show');
        }
        } else {
          this.click = !this.click;
          if (this.click == false) {
             $(".dropdown-menu").dropdown('hide');
          }
        }
      }
    },
    onmouseover() {
      if (screen.width > 992) {
        $('.dropdown-toggle').trigger('click');
        $('.dropdown-menu').dropdown('show');
      }
    },
    onmouseleave() {
      if (screen.width > 992) {
        $(".dropdown-menu").dropdown('hide');
        $(".dropdown-toggle").blur();
      }
    }

  }
};
</script>

